module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "kimberly.a920b104.svg";